import { Component, HostListener, Input, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'popover-component',
    templateUrl: './popover.component.html',
    styleUrls: ['./popover.component.css']
})

export class PopoverComponent implements OnInit,OnDestroy{

  @Input()
  data: string[];
  isComplete: boolean;

  constructor() {
  }
  ngOnInit(): void {
    if(this.data == undefined){
      this.isComplete = true
    }
  }
  ngOnDestroy(): void {
  }

}
